export const findLabel = (array, id) => array.find((s) => s.id == id)
export const findActionLabel = (array, action) => array.find((item) => item.value === action)

export const makeTable = (lines, table, stages = [], actions = []) => {
	const linesList = []

	lines.forEach((line) => {
		let status = null,
			stage = null,
			action = null

		stage = findLabel(stages, line.funnel_stage_id)
		if (stage) status = findLabel(stage.status, line.funnel_stage_status_id)
		action = findActionLabel(actions, line.action)

		linesList.push({
			...line,
			table: table,
			label: action.name || '-',
			funnel_stage_name: !!stage ? stage.name : '-',
			funnel_stage_status_name: !!status ? status.name : '-',
		})
	})
	return linesList
}

export const makeColumns = () => [
	{ title: 'Ação' },
	{ title: 'Etapa' },
	{ title: 'Status' },
	{ title: '', size: '50' },
]
